import { render, staticRenderFns } from "./IconRemove.vue?vue&type=template&id=de176d6c&"
import script from "./IconRemove.vue?vue&type=script&lang=js&"
export * from "./IconRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de176d6c')) {
      api.createRecord('de176d6c', component.options)
    } else {
      api.reload('de176d6c', component.options)
    }
    module.hot.accept("./IconRemove.vue?vue&type=template&id=de176d6c&", function () {
      api.rerender('de176d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconRemove.vue"
export default component.exports